
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface FormButtonsProps {
  isDeploying: boolean;
  isFormValid?: boolean;
}

export function FormButtons({ isDeploying, isFormValid = true }: FormButtonsProps) {
  return (
    <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
      <Button
        type="submit"
        className="flex-1"
        disabled={isDeploying || !isFormValid}
      >
        {isDeploying ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Creating Token...
          </>
        ) : (
          "Create Token"
        )}
      </Button>
      
      <Button
        type="button"
        variant="outline"
        className="flex-1"
        disabled={isDeploying}
        onClick={() => window.location.href = '/'}
      >
        Cancel
      </Button>
    </div>
  );
}
